import { Router } from '@angular/router';
import { ByocUploadContentService } from './../../service/upload-content.service';
import { ByocEpisodeService } from '../../service/episode.service';
import { Component, OnDestroy, ChangeDetectionStrategy, inject } from '@angular/core';

@Component({
    selector: 'app-byoc-episode-step-uploaded-content-status-info',
    templateUrl: './uploaded-content-status-info.component.html',
    styleUrls: ['./uploaded-content-status-info.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ByocEpisodeStepUploadedContentStatusInfoComponent implements OnDestroy {
    private byocEpisodeService = inject(ByocEpisodeService);
    private byocUploadContentService = inject(ByocUploadContentService);
    private router = inject(Router);

    get contentName() {
        return this.byocEpisodeService.form.get('title')!.value;
    }

    get contentType() {
        return this.byocUploadContentService.uploadType;
    }

    get isReuploadContent() {
        return this.byocUploadContentService.episodeToEditId;
    }

    ngOnDestroy(): void {
        if (this.isReuploadContent) {
            this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'list']);
        }
    }
}
